"use client";

const TRIAL_SESSION_ID_KEY = "sr_trial_session_id";

export function getOrCreateTrialSessionId(): string {
  if (typeof window === "undefined") return "";
  let id = sessionStorage.getItem(TRIAL_SESSION_ID_KEY);
  if (!id) {
    id = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem(TRIAL_SESSION_ID_KEY, id);
  }
  return id;
}
